import PedidoCuentaShow from './PedidoCuentaShow'
export {PedidoCuentaShow}
export default PedidoCuentaShow
